<template>
  <div v-show="!formShow.visible">
    <a-button
      type="link"
      @click="
        () => {
          formShow.visible = true;
          if (!is_all) {
            field_render_show = true;
          }
          $emit('resize');
        }
      "
    >
      展开
    </a-button>
    <a-tag
      color="green"
      v-for="field in form.fields"
      v-show="model[field.name] != null && model[field.name] != ''"
    >
      {{ field.label }}:{{ showLabel(field, field.name) }}
    </a-tag>
  </div>
  <a-form
    v-show="formShow.visible"
    ref="form"
    autocomplete="off"
    :model="model"
    :rules="form.rules"
    :layout="form.settings.layout"
    :label-col="form.settings.labelCol"
    :wrapper-col="form.settings.wrapperCol"
    :labelAlign="form.settings.labelAlign"
    scrollToFirstError
  >
    <a-form-item v-if="showSearch">
      <a-button
        type="link"
        @click="
          () => {
            formShow.visible = false;
            $emit('resize');
          }
        "
      >
        隐藏
      </a-button>
    </a-form-item>
    <field-render
      v-for="field in form.fields"
      v-model:value="model[field.name]"
      v-model:label="labelModel[field.name]"
      :field="field"
      :field_render_show="field_render_show"
      :formModel="model"
      :key="field.name"
      :validateInfos="validateInfos"
      :options="options[field.datasource ? field.datasource : field.name]"
    />
    <a-form-item v-if="showSearch">
      <a-button size="small" type="primary" @click="search">查询</a-button>
    </a-form-item>
    <a-form-item v-if="showReset">
      <a-button size="small" @click="resetFields">重置</a-button>
    </a-form-item>
    <a-form-item v-if="showSearch && !field_render_show && is_zhankai">
      <a-button size="small" @click="show_all">展开</a-button>
    </a-form-item>
    <a-form-item v-if="showSearch && field_render_show && is_zhankai">
      <a-button size="small" @click="show_part">收起</a-button>
    </a-form-item>
    <a-form-item v-if="showReport">
      <a-button size="small" type="info" @click="editModal.visible = true">订阅</a-button>
    </a-form-item>
  </a-form>
  <a-modal
    v-if="editModal.visible"
    :visible="editModal.visible"
    @cancel="
      () => {
        editModal.visible = false;
      }
    "
  />
</template>
<script language="ts">
import { watch } from 'vue';

export default {
  name: 'SearchRender',
  components: {},
  emits: ['search', 'resize'],
  props: {
    model: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
    resetFields: {
      type: Function,
      default: () => {},
    },
    showReport: {
      type: Boolean,
      default: () => false,
    },
    showSearch: {
      type: Boolean,
      default: () => true,
    },
    showReset: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    let is_formShow = false;
    let is_all = false;
    let is_zhankai = false;
    this.form.fields.map(item => {
      if (item?.is_search_show !== false) {
        is_formShow = true;
        is_all = true;
      }
      if (item?.is_search_show === false) {
        is_zhankai = true;
      }
    });
    return {
      editModal: {
        visible: false,
      },
      formShow: {
        visible: is_formShow,
      },
      is_all: is_all,
      is_zhankai: is_zhankai,
      labelModel: {},
      field_render_show: false,
    };
  },
  methods: {
    search() {
      this.$refs.form.validate().then(
        () => {
          this.$emit('search');
          if (this.field_render_show) {
            this.formShow.visible = false;
          }
        },
        () => {
          // this.$emit('search');
        },
      );
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.resetFields();
    },
    show_all() {
      this.field_render_show = true;
    },
    show_part() {
      this.field_render_show = false;
    },
    disable(name) {
      this.form.fields[name].disabled = true;
    },
    disableAll() {
      this.form.fields.forEach(item => {
        item.disabled = true;
      });
    },
    showLabel(field, name) {
      const options = this.options[field.datasource ? field.datasource : field.name];
      if (this.labelModel[name] != undefined) {
        return this.labelModel[name];
      } else if (options) {
        if (
          typeof this.model[name] == 'object' &&
          this.model[name] != undefined &&
          this.model[name].length >= 0
        ) {
          const selectItems = options
            .filter(item => this.model[name].includes(item.value))
            .map(item => item.name);
          if (selectItems.length > 0) {
            return selectItems;
          }

          return '';
        } else {
          const selectItem = options.find(item => item.value == this.model[name]);
          if (selectItem) {
            return selectItem.name;
          }
          return '';
        }
      } else {
        return this.model[name];
      }
    },
  },
  created() {
    if (this.form.watch) {
      for (let k in this.form.watch) {
        watch(
          () => this.model[k],
          () => {
            this.form.watch[k](this.model, this.form);
          },
        );
      }
    }
  },
};
</script>
